export default "__VITE_ASSET__BNgfmuSU__"